var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -61 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m437 0h-362c-41.398438 0-75 33.601562-75 75v240c0 41.398438 33.601562 75 75 75h362c41.398438 0 75-33.601562 75-75v-240c0-41.398438-33.601562-75-75-75zm0 0",
    fill: "#ff3939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 75v240c0 41.398438-33.601562 75-75 75h-181v-390h181c41.398438 0 75 33.601562 75 75zm0 0",
    fill: "#c90232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 136.199219-75-41.699219v204l75-43.199219 105.601562-60.601562zm0 0",
    fill: "#ececf1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m361.601562 194.699219-105.601562 60.601562v-119.101562zm0 0",
    fill: "#e2e2e7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7bd9f19b8d5fb94beca1a52d3fa3c9c9.svg";
export { ForwardRef as ReactComponent };